mod.modules.define("ActionBar", function (fn) {

	fn.prototype.init = function (params) {

	};

	fn.prototype.events = {
		"a[data-toggle]": {
			"click": function (e, $el) {
				$el.parent().toggleClass('selected').siblings().removeClass('selected');
			}
		}
	};

});